<section class="grid-view">
    @if (!isActive() && currentSurveys().length === 0) {
    <p class="uscb-padding-T-0 uscb-padding-L-0 uscb-font-1x">No completed surveys</p>
    }
    @if (currentOverdueMessage() && currentOverdueMessage().length > 0 && isActive()) {
    <div class="ecorr-survey-card-overdue-message" tabindex="0">
        {{ currentOverdueMessage() }}
    </div>
    }
    <div class="uscb-margin-B-50">
        <div class="survey-cards top-padding uscb-layout-column-sm uscb-layout-column-md uscb-layout-column-lg uscb-layout-row-gt-lg">
            @if (currentSurveys().length !== 0) {
            <div class="survey-card-grid uscb-flex-row-sm-100 uscb-flex-row-md-100 uscb-flex-row-lg-100 uscb-flex-row-gt-lg uscb-padding-0">
                <section class="uscb-padding-0 fx-row-wrap">
                    @for (survey of currentSurveys(); track survey.surveyInstanceId; let i = $index) {
                    <div class="uscb-flex-row uscb-padding-0">
                        <app-grid-view-instance card-id="{{'card-' + survey.surveyInstanceId}}" [survey]="survey" [active]="isActive()">
                        </app-grid-view-instance>
                    </div>
                    }
                </section>
            </div>
            }
            <div class="uscb-flex-row-sm-100 uscb-flex-row-md-100 uscb-flex-row-lg-100 uscb-flex-row-gt-lg uscb-padding-0">
                @if (isActive()) {
                <section class="uscb-padding-0">
                    <mat-card class="survey-card add-survey-card uscb-margin-10 uscb-layout-column" tabindex="0">
                        <mat-card-content class="uscb-flex-row">
                            <div class="uscb-position-absolute">
                                <div class="uscb-title-3">New Survey Request</div>
                                <div class="uscb-font-1x">{{ currentAddSurveyText() }}</div>
                            </div>
                            <div class="uscb-position-relative ecorr-icon-background">
                                <i class="fa fa-plus-circle uscb-color-accent"></i>
                            </div>
                        </mat-card-content>
                        <div class="uscb-flex-row">
                            <mat-divider role="presentation"></mat-divider>
                        </div>
                        <mat-card-actions class="uscb-flex-row uscb-layout-column">
                            <div class="uscb-flex-row uscb-padding-10">
                                <button type="button" class="uscb-primary-button" (click)="addSurvey()" (keyup.enter)="addSurvey()" tabindex="0">
                                    <i class="fa fa-plus-circle"></i> &nbsp; ADD AUTHENTICATION CODE
                                </button>
                            </div>
                        </mat-card-actions>
                    </mat-card>

                    <app-canister></app-canister>

                    <!-- <button type="button" class="uscb-primary-button" (click)="testFn()" (keyup.enter)="testFn()">"BURN" BRDS CODE</button> -->
                </section>
                }
            </div>
        </div>
    </div>
</section>